export default __webpack_public_path__ + "static/media/google-app (2).e458125c.png";